import { createSubscribableMutator } from './create-subscribable-mutator';
/**
 * Simple wrapper for the creation for subscribable mutators for rest calls via graphql.
 *
 * @see createSubscribableMutator
 */
export const createSubscribableRestMutator = (mutation, subscribableMutatorOptions) => createSubscribableMutator(mutation, {
    withRest: true,
    useCustomMutationHook: subscribableMutatorOptions === null || subscribableMutatorOptions === void 0 ? void 0 : subscribableMutatorOptions.useCustomMutationHook,
});
